module.exports = __webpack_public_path__ + "img/NGR_Logo_W.56d517b2.png";